import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    MenuItem,
    CircularProgress,
    Accordion
} from '@material-ui/core';
import { SelectCommissionHold } from 'Components/Api/CommissionHoldAPI';
import { Insert as REQUEST_INSERT } from 'Components/Api/CommissionHoldAPI';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_SELECT_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import { logout } from 'Components/Helper/Helpers';

import {
    GET_Month_FOR_GST,
    GET_YEAR_FOR_GST
} from 'Components/Helper/Messages';

import { PrimaryButton } from 'Components/Inputes/CustomButton';

import { ADMIN_CODE, SUPPORT_CODE } from 'Components/Helper/Messages';
const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const CommissionHold = () => {
    const formRef = useRef();
    const classes = commonStyle();

    const [tableItems, setTableItems] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isAdminRole, setIsAdminRole] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);

    const [openFilter, setOpenFilter] = useState(true);
    const [TakeCount, setTakeCount] = useState(100);
    const [SkipCount, setSkipCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    var currentUsertypeid = localStorage.getItem('UserTypeID');
    const [Months] = useState([
        { Key: 1, Value: 'January' },
        { Key: 2, Value: 'February' },
        { Key: 3, Value: 'March' },
        { Key: 4, Value: 'April' },
        { Key: 5, Value: 'May' },
        { Key: 6, Value: 'June' },
        { Key: 7, Value: 'July' },
        { Key: 8, Value: 'August' },
        { Key: 9, Value: 'September' },
        { Key: 10, Value: 'October' },
        { Key: 11, Value: 'November' },
        { Key: 12, Value: 'December' }
    ]);

    const [Years, setYears] = useState([]);

    const [ModelObj] = useState({
        Month: isAdminRole ? GET_Month_FOR_GST() : new Date().getMonth(),
        Year: GET_YEAR_FOR_GST()
    });

    const GetYears = () => {
        var currentYear = new Date().getFullYear();
        var yearList = [];
        for (var year = currentYear - 1; year <= currentYear; year++) {
            yearList.push({ Key: year });
        }
        setYears(yearList);
    };

    const CheckUserRole = () => {
        if (ADMIN_CODE === parseInt(currentUsertypeid)) setIsAdminRole(true);
        if (SUPPORT_CODE === parseInt(currentUsertypeid)) setIsAdminRole(true);

        createColumns();
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setTableItems([]);
        let requestJSON = JSON.stringify(values);

        const { data, status, isAuthorized } = await SelectCommissionHold(
            requestJSON
        );

        setLoading(false);
        if (!isAuthorized) logout();
        if (!status) {
            setIsError(true);
            setResponseMessage(data);
            setSeverity('error');
            return;
        }
        var d = JSON.parse(data);
        setTableItems(d);
        setSubmitting(false);
    };

    const Requestsend = async (values) => {
        var inputObj = {
            UserID: values[3],
            Month: values[4],
            Year: values[5],
            LastYearMonth: values[6],
            Amount: values[9],
            WalletID: values[12]
        };

        var requestObj = JSON.stringify(inputObj);

        setIsError(false);
        setLoading(true);

        var response = await REQUEST_INSERT(requestObj);

        setLoading(false);

        if (!response.isAuthorized) logout();

        setResponseMessage(response.data);
        setIsError(true);

        setSeverity('success');
        if (!response.status) {
            setSeverity('error');
            return;
        }
    };

    const validationSchema = Yup.object({
        Month: Yup.string()
            .nullable(PLEASE_SELECT_VALID + 'month')
            .required(PLEASE_SELECT_VALID + 'month'),
        Year: Yup.string()
            .nullable(PLEASE_SELECT_VALID + 'year')
            .required(PLEASE_SELECT_VALID + 'year')
    });

    useEffect(() => {
        GetYears();
        CheckUserRole();
        createColumns();
    }, [isAdminRole]);

    const createColumns = () => {
        var columns = [];
        var statusIndex = 1;
        columns.push({
            label: 'Status',
            name: 'Status',
            hide: true
        });
        columns.push({
            label: '#',
            name: 'ID',
            srno: true
        });
        columns.push({
            label: 'UserID',
            name: 'UserID',
            hide: true
        });
        columns.push({
            label: 'Month',
            name: 'Month',
            hide: true
        });
        columns.push({
            label: 'Year',
            name: 'Year',
            hide: true
        });

        columns.push({
            label: 'LastYearMonth',
            name: 'LastYearMonth',
            actived: true
        });
        columns.push({
            label: 'Wallet',
            name: 'WalletName'
        });

        columns.push({
            label: 'FirmName',
            name: 'FirmName',
            actived: true
        });
        columns.push({
            label: 'Total Success Amount',
            name: 'TotalSuccessAmount',
            numeric: true
        });
        columns.push({
            label: 'Comm hold Amount',
            name: 'CommissionHoldAmount',
            numeric: true
        });

        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });
        columns.push({
            label: 'WalletID',
            name: 'WalletID',
            hide: true
        });

        var options = [
            {
                Title: 'Request',
                disabledOn: ['SUCCESS', 'PROCESS'],
                statusIndex: statusIndex,
                Callback: (values) => {
                    Requestsend(values);
                }
            }
        ];
        columns.splice(0, 0, {
            label: ' ',
            name: 'TransactionMasterID',
            MoreMenu: true,
            options: options
        });
        setMainColumns(columns);
    };

    const MonthItems = Months.map(({ Key, Value }, index) => (
        <MenuItem key={index} value={Key}>
            {Value}
        </MenuItem>
    ));
    const YearItems = Years.map(({ Key }, index) => (
        <MenuItem key={index} value={Key}>
            {Key}
        </MenuItem>
    ));

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                innerRef={formRef}
                initialValues={ModelObj}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                resetForm={ModelObj}
            >
                {({ setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <Grid item xs={12}>
                                <CustomAccordion
                                    title={'Commission Hold'}
                                    open={openFilter}
                                    setOpen={(value) => setOpenFilter(value)}
                                >
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialSelect
                                                label="Month"
                                                name="Month"
                                                title="Month"
                                            >
                                                {MonthItems}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialSelect
                                                label="Year"
                                                name="Year"
                                                title="Year"
                                            >
                                                {YearItems}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Search"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loading}
                                            >
                                                Search
                                            </PrimaryButton>
                                            {loading && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </CustomAccordion>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <ReactTable
                data={tableItems}
                columns={mainColumns}
                count={totalCount}
                rowsPerPage={TakeCount}
                serverSide={true}
                getCallback={({ currentPage, RowsPerPage }) => {
                    setCurrentPage(currentPage);
                    setTakeCount(RowsPerPage);
                    setSkipCount(RowsPerPage * currentPage);
                }}
                getSearchCallback={({ SearchText }) => {}}
                getSortCallback={({ column, direction }) => {}}
            />
        </CustomContainer>
    );
};
